import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
	startScreenSharing: {
		id: 'headerSelect.startScreenSharing',
		defaultMessage: 'Включить демонстрацию экрана',
	},
	stopScreenSharing: {
		id: 'headerSelect.stopScreenSharing',
		defaultMessage: 'Отключить демонстрацию экрана',
	},
	sendHistoryToEmail: {
		id: 'headerSelect.sendHistoryToEmail',
		defaultMessage: 'Отправить диалог на E-mail',
	},
});
